import { loadable } from '../../services/loadable';

export const DevPanel = loadable(() => import('./dev-panel'));
